export default function cleanStack(stack: string | undefined) {
  return stack || "";
}
